import {Link} from "react-router-dom";
import Icon from "../../components/selfcare/Icon.tsx";
import {Categories} from "./categories.ts";
import {uid} from "../../components/raffle/uid.ts";
import setTitleAndMetaDescription from "../../components/setTitleAndMetaDescription.tsx";
import RaffleSearchBoxComponent from "../../components/help/RaffleSearchBoxComponent.tsx";
import useRouteDatalayer from "../../components/useRouteDatalayer.tsx";
import IconServiceStatus from "../../components/icons/IconServiceStatus.tsx";

const Title = "Få hjælp til dit bredbånd via vores hjælpeunivers - Hiper"
const Description = "Hvis du har brug for hjælp til dit bredbånd, finder 92% deres svar via vores søgefelt. Vores hjælpeunivers består af gode hjælpeartikler."

export default function HelpHomePage() {
    setTitleAndMetaDescription(Title, Description)

    useRouteDatalayer("hjaelp")

    return (
        <div className={"page-help"}>
            <section className="content">
                <div className="header">
                    <h1 className="heading heading--big">Har du brug for hjælp?</h1>
                </div>
            </section>

            <RaffleSearchBoxComponent uid={uid.help}/>

            <section className="content content--wide help-content">
                <ul className="help-menu help-menu--category">
                    <li className="item">
                        <a href={"https://drift.hiper.dk"} target={"_blank"}>
                            <Icon component={IconServiceStatus}/>
                            <h2 className="headline heading--smaller">Driftsstatus</h2>
                            <p className="summary">
                                Se om der er driftsforstyrrelser i dit område.
                            </p>
                        </a>
                    </li>
                    {Object.entries(Categories).map(([key, category]) => {
                        return (
                            <li key={key} className="item">
                                <Link to={`/hjaelp/${category.link}`}>
                                    <Icon component={category.icon}/>
                                    <h2 className="heading heading--smaller">{category.cat_name}</h2>
                                    <p className="summary">{category.summary}</p>
                                </Link>
                            </li>
                        )
                    })}
                </ul>

                <div className="blurb">
                    <h3 className="heading heading--medium">Mest besøgte artikler</h3>
                </div>
                <ul className="help-menu help-menu--most-viewed">
                    <li className="item">
                        <Link to={`/hjaelp/internet-og-wifi/skift-navn-og-kode-paa-wifi`}>
                            Skift navn og kode på wifi
                        </Link>
                    </li>
                    <li className="item">
                        <Link to={`/hjaelp/udstyr/installationsmanual`}>
                            Sådan installerer du din router
                        </Link>
                    </li>
                    <li className="item">
                        <Link to={`/hjaelp/internet-og-wifi/forventninger-til-wifi`}>
                            Hvad kan jeg forvente af mit wifi?
                        </Link>
                    </li>
                    <li className="item">
                        <Link to={`/hjaelp/udstyr/kan-jeg-bruge-mit-eget-udstyr`}>
                            Kan jeg bruge mit eget udstyr?
                        </Link>
                    </li>
                    <li className="item">
                        <Link to={`/hjaelp/internet-og-wifi/placering-af-router`}>
                            Hvor er det bedst at placere sin router?
                        </Link>
                    </li>
                    <li className="item">
                        <Link to={`/hjaelp/mit-abonnement/returner-udstyr`}>
                            Returnering af udstyr
                        </Link>
                    </li>
                </ul>
            </section>
        </div>
    )
}
